export const initialDesignItemBackground = {
  type: 'BackgroundMedia',
  colorLayers: [
    {
      type: 'SolidColorLayer',
      opacity: 0,
      fill: {
        type: 'SolidColor',
        color: 'color_11',
      },
    },
  ],
  colorOverlay: '',
};

export const supportedGradientSkins: Record<string, boolean> = {
  'wysiwyg.viewer.skins.area.DefaultAreaSkin': true,
};
